import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../lib/api-client";

export interface CompanyLocation {
    locationID: number,
    locationName: string,
    defaultLocationFlag: boolean,
    taxRate: number
}

export const useGetLocations = (companyID: number, enabled: boolean = true) => {
    const { data, isLoading } = useQuery({
        queryKey: ['locations', companyID],
        queryFn: async () => await apiClient.get('company/locations') as CompanyLocation[],
        enabled: enabled
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
